export default __webpack_public_path__ + "static/media/DE.415243e1.ico";